import React, { PureComponent } from 'react';
import MeasurementLayerBase from './MeasurementLayerBase';
import './MeasurementLayer.css';
import MeasurementButtons from './MeasurementButtons';

export default class MeasurementLayer extends PureComponent {
  state = { mode: null, isShiftPressed: false, parentSize: { width: 0, height: 0 } };

  constructor(props) {
    super(props);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.onWindowKeyUp = this.onWindowKeyUp.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
  }

  componentDidUpdate() {
    this.checkImageHeightAndWidthUpdate()
    if (this.props.addLineClicked) {
      this.toggleMode('line')
    }
  }

  onWindowKeyDown(val) {
    if (val.keyCode === 16 || val.key === 'Shift') {
      this.setState({mode: this.state.mode, isShiftPressed: true});
    }
  }

  onWindowKeyUp(val) {
    if (val.keyCode === 16 || val.key === 'Shift') {
      this.setState({mode: this.state.mode, isShiftPressed: false});
    }
  }

  componentDidMount() {
    if (this.props.addLineClicked && !this.props.measurements?.length) {
      this.toggleMode('line')
    }
    this.checkImageHeightAndWidthUpdate()
    window.addEventListener('keydown', this.onWindowKeyDown);
    window.addEventListener('keyup', this.onWindowKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onWindowKeyDown);
    window.removeEventListener('keyup', this.onWindowKeyUp);
  }

  getParentSize = () => {
    if (this.root) {
      const { width, height } = this.root.getBoundingClientRect();
      return { width, height };
    }
    return { width: 0, height: 0 };
  };

  checkImageHeightAndWidthUpdate = () => {
    const size = this.getParentSize();
  // Only update state if size has changed
  if (JSON.stringify(this.state.parentSize) !== JSON.stringify(size)) {
    this.setState({ parentSize: size });
  }
  }

  render() {
    const hasSize = this.props.widthInPx > 0 && this.props.heightInPx > 0;
    return hasSize ? (
      <div
        className="measurement-layer"
        style={{
          width: this.props.isFullscreen ? '100%' : 'calc(100vw - 225px)',
          height: this.props?.heightInPx,
        }}
        ref={(e) => (this.root = e)}>
        <MeasurementLayerBase
          measurementUnit={this.props.showUnit ? this.props.unitValue || 'inches': ''}
          measurements={this.props.measurements}
          onChange={this.props.onChange}
          widthInPx={this.props?.isListView ? this.state.parentSize?.width || this.props.widthInPx : this.props.widthInPx}
          heightInPx={this.props?.isListView ? this.state.parentSize?.height || this.props.heightInPx : this.props.heightInPx}
          measureLine={this.props.measureLine}
          measureCircle={this.props.measureCircle}
          mode={this.state.mode}
          onCommit={this.onCommit}
          styleApplied={this.props.styleApplied}
          changeTextVal={this.props.changeTextVal}
          disablePan={this.props.disablePan}
          isMeasureToolEditable={this.props.isMeasureToolEditable}
          updateSelection={this.props.updateSelection}
          clickedOutsideAllLines={this.props.clickedOutsideAllLines}
          isShiftPressed={this.state.isShiftPressed}
          scale={this.props.scale}
        />
      </div>
    ) : null;
  }

  toggleMode = (mode) => {
    const newCentredLine = {
      endX: 0.66,
      endY: 0.50,
      id: this.props.measurements.length,
      startX: 0.33,
      startY: 0.50,
      textValue: 33,
      type: 'line',
      selected: true,
      styleApplied: { ...this.props.styleApplied, edgeAngle: null }
    }
    let oldMeasurements = JSON.parse(JSON.stringify(this.props.measurements));
    oldMeasurements = oldMeasurements.map((data) => {
      data.selected = false;
      return data;
    });
    this.props.onChange([...oldMeasurements, newCentredLine], this.props.addLineClicked);
    this.props.disablePan(mode === this.state.mode ? false: true);
    this.setState({ mode: mode === this.state.mode ? null : mode, isShiftPressed: false });
    this.props.setAddLineClicked(false);
    setTimeout(() => {
      this.setState({ mode: null });
    }, 500);
  }

  onCommit = (measurement, str) => {
    this.props.disablePan(false);
    this.setState({ mode: null, isShiftPressed: false });
    let oldMeasurements = JSON.parse(JSON.stringify(this.props.measurements));
    if (this.props.onChange && oldMeasurements?.length) {
      if (str !== 'delete') {
        for (let i = 0; i < oldMeasurements?.length; i++) {
          if (oldMeasurements[i].id === measurement.id) {
            oldMeasurements[i] = measurement;
            break;
          }
        }
        const isAddLineClicked = str !== 'drag-end';
        this.props.onChange(oldMeasurements, isAddLineClicked);
      } else {
        let newMeasurement = [];
        for (let i = 0; i < oldMeasurements?.length; i++) {
          if (oldMeasurements[i].id !== measurement.id) {
            newMeasurement.push(oldMeasurements[i]);
          }
        }
        this.props.onChange(newMeasurement, true);
      }
    }
  };
}
